import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
// import { LibrariesCard } from "../../shared/libraries-card/libraries-card";
import { BaseCarouselComponent } from '../../base/base-carousel-component';
import { HomeService } from './home.service';

import { BiblioMapper } from '../../features/browse-index/mappers/biblio.mapper';
import { map } from 'rxjs/operators';
import { Router, RouterLink } from '@angular/router';
// import { Library } from '../../types/library';
import { FooterComponent } from '../../shared/footer/footer.component';
import { Library } from '../../types/library';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-home',
  imports: [FormsModule,FooterComponent, TranslateModule, CommonModule, RouterLink],
  templateUrl: './home.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  styleUrl: './home.scss',
})
export class Home extends BaseCarouselComponent implements OnInit {

  _homeService = inject(HomeService);
  _router = inject(Router);
  public translateService = inject(TranslateService);
  searchInputValue: string = ''
  topLibraries$ = this._homeService.getTopLibraries();
  timePeriods$ = this._homeService.getTimePeriods();
  quranCalligraphies$ = this._homeService.getQuranCalligraphies();
  quranDecorations$ = this._homeService.getQuranDecorations();
  complexInfo$ = this._homeService.getComplexInfo();
  statistics$ = this._homeService.getDspaceStatistics();
  media: Library[] = [];
  public environment = environment;

  
  override ngOnInit(): void {
    super.ngOnInit();
  }



  onSearchClick(value: string) {

    this._router.navigate(
      ['/browse-index'],
      {
        queryParams: {
          q: value
        }
      })
  }

  formatHijriYear(dateStr?: string): string {
    if (!dateStr) return '';
    try {
      const date = new Date(dateStr);
      // use standard JS formatter with islamic civil calendar
      const formatter = new Intl.DateTimeFormat('ar-SA-u-ca-islamic', { year: 'numeric' });
      return formatter.format(date);
    } catch {
      return '';
    }
  }
}

